export default "__VITE_ASSET__Bk52MpS2__"